import useTranslation from 'next-translate/useTranslation'
import Image from 'next/legacy/image'
import Link from 'next/link'
import React, { FC, memo } from 'react'
import { FlexboxGrid, Panel } from 'rsuite'
import { useRouter } from 'next/router'
import omit from 'lodash/omit'

import useUrls from '../../services/useUrls'
import { getSmallPreview, imageLoader } from '../../utils/images'
import { ProductMedia } from '../../utils/types/Product'
import FallBackCategoryImg from '../Graphics/FallBackCategoryImg'
import { getFilterQueryIds } from './Pickers/util'
import { QueryParam } from '../../utils/constants'

import styles from '../../styles/CategoryCard.module.less'

interface CategoryCardProps {
  categoryName: string
  value: string
  url: string
  media?: ProductMedia[]
}

const CategoryCard: FC<CategoryCardProps> = (props) => {
  const { categoryName, value, media, url } = props

  const { urlT } = useUrls()
  const { t } = useTranslation('catalog')
  const { query } = useRouter()

  const [, parentCategory = ''] = query[QueryParam.filters] || []
  const categoryImgAlt = t('meta:categoryThumbnailAltDescription', { categoryName })
  const currentQueries = Object.entries(omit(query, getFilterQueryIds(query)))
    .reduce((queryString, [key, queryValue], index) => (
      `${queryString}${index === 0 ? '?' : '&'}${key}=${queryValue}`
    ), '')
  const categoryUrl = urlT(parentCategory ? `${url}/category/${parentCategory}/${value}${currentQueries}` : `${url}/category/${value}${currentQueries}`)

  return (
    <div className={styles['category-card']}>
      <Link
        href={categoryUrl}
        shallow
      >
        <Panel
          bordered
          bodyFill
        >
          <FlexboxGrid justify="center">
            <FlexboxGrid.Item className={styles.body}>
              <FlexboxGrid
                justify="center"
                className={`relative ${styles['image-container']}`}
              >
                {media?.[0]['media.url'] ? (
                  <div className={styles['image-container-height']}>
                    <Image
                      loader={imageLoader}
                      src={getSmallPreview(media[0])}
                      alt={categoryImgAlt}
                      layout="fill"
                    />
                  </div>
                ) : (
                  <FallBackCategoryImg />
                )}
              </FlexboxGrid>
              <div className={styles['category-name']}>{t(categoryName)}</div>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </Panel>
      </Link>
    </div>
  )
}

export default memo(CategoryCard)
